// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBeeTSMk1y2zMTkCJrRUnpp-NDH5__gG2U",
  authDomain: "apartments-49bc7.firebaseapp.com",
  projectId: "apartments-49bc7",
  storageBucket: "apartments-49bc7.appspot.com",
  messagingSenderId: "333120564572",
  appId: "1:333120564572:web:72c82900dd3a560cede599",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export const auth = getAuth();

export const db = getFirestore();

export const functions = getFunctions(app);

const isEmulator = process.env.REACT_APP_FIREBASE_EMULATOR === "true";
if (isEmulator) {
  connectFirestoreEmulator(db, "localhost", 8080);
}
